import { baseGet } from '../helpers/api';

export async function getHierarchyByUser({
  userId,
  isAdmin,
  orgId,
}) {
  if (!orgId) return null;
  const targetUserID = isAdmin
    ? '9-9999999999999999999999999999999999'
    : userId;

  const data = await baseGet(
    `hierarchy/getHierarchyByUser?userId=${targetUserID}&orgId=${orgId}`,
  );
  // sanatize
  if (!data) return null;
  const hierarchyByUserMapped = data.map((level, index) => {
    const nextLevel = data[index + 1];
    return {
      text: level.text,
      users: level.users.map(user => {
        const reportees = nextLevel?.users
          ?.filter(nextUsers => user.locations.some(loc => nextUsers.locations.includes(loc)))
          .map(user => user.label) || [];
        const locations = user.locations.map(loc => {
          // wtf myq
          if (typeof loc === 'string') return loc.replace('loc-', '');
          return loc;
        });
        return {
          label: user.label.replace(/[^\w\s]/gi, ''),
          locations,
          reportees: reportees.map(reportee => reportee.replace(/[^\w\s]/gi, '')),
        };
      }),
    };
  });
  return hierarchyByUserMapped;
}

export async function getHierarchyPeersByUser({ userId, orgId, isAdmin }) {
  if (!orgId) return null;
  const targetUserID = isAdmin
    ? '9-9999999999999999999999999999999999'
    : userId;
  const data = await baseGet(
    `hierarchy/getPeersByUser?userId=${targetUserID}&orgId=${orgId}`,
  );
  if (!data) return null;
  const hierarchyPeersByUserMapped = data.map(person => ({
    label: person.label.replace(/[^\w\s]/gi, ''),
    locations: person.locations.map(loc => {
      // wtf myq
      if (typeof loc === 'string') return loc.replace('loc-', '');
      return loc;
    })
  }));
  return hierarchyPeersByUserMapped;
}